exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".ic_avatar{\n  display: inline-block;\n  float: left;\n  margin-top: 2px;\n  border: 1px solid #fff;\n  border-radius: 50%;\n}\n\n#table_item td{\n    padding-top:12px;\n    border-bottom : 1px solid #eef0f0;\n    padding-bottom: 5px;\n}\n\n.div_status{\n    display: inline-block;\n    width: 12px;\n    height: 12px;\n    border-radius: 100%;\n    \n}\n.status-active{\n    background-color:red;\n}\n\n.status-inactive{\n    background-color:#fff;\n    border: 2px solid #979797;\n}\n\n.span-lg{\n    padding-left: 15px;\n    font-size: 15px;\n}\n.span-lg-active{\n    font-weight:bold;\n    color:#5b6c72;\n}\n\n.span-lg-inactive{\n    font-weight:bold;\n    color:#9b9b9b;\n}\n\n.span-sm{\n    color:#9c9c9c;\n    padding-left: 15px;\n}\n\n.span-sm-active{\n    font-weight:bold;\n}\n\n.empty-msg{\n    margin: 40px;\n}\n\np{\n    color: #a3a3a3;\n}\n\np .fa{\n    color: #dcdcdc;\n    font-size: 50px;\n    font-weight: bold;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/src/app/pages/item-last-message/item-last-message.component.css
// module id = ../../../../../src/app/pages/item-last-message/item-last-message.component.css
// module chunks = main